import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { IconGoogle } from '../../../../app/icons/google';
import { IconApple } from '../../../../app/icons/apple';
import { Divider } from '../../../../app/divider/divider';
import { Button } from '../../../../app/form/button/button';
import { useRootStore } from '../../../../../providers/root-store-provider';
import { Tooltip } from '../../../../app/tooltip/tooltip';

export const ThirdPartyLogin: React.FC = observer(() => {
    const { t } = useTranslation();
    const router = useRouter();
    const {
        authStore: { authDialogStore },
        alertStore,
        cookieService,
    } = useRootStore();

    const onGoogleLogin = () => {
        if (authDialogStore.activeModal !== 'signUp' || authDialogStore.agreedTerms) {
            cookieService.setAgreedTerms(authDialogStore.agreedTerms);
            cookieService.setAgreedMarketing(authDialogStore.agreedMarketing);

            router.push(`${process.env.NEXT_PUBLIC_API_URL}/auth/google`);
        } else {
            alertStore.setErrorMessage(t('layout.forms.common.agreeTermsValidation'));
        }
    };

    const onAppleLogin = () => {
        if (authDialogStore.activeModal !== 'signUp' || authDialogStore.agreedTerms) {
            cookieService.setAgreedTerms(authDialogStore.agreedTerms);
            cookieService.setAgreedMarketing(authDialogStore.agreedMarketing);

            router.push(`${process.env.NEXT_PUBLIC_API_URL}/auth/apple`);
        } else {
            alertStore.setErrorMessage(t('layout.forms.common.agreeTermsValidation'));
        }
    };

    const isDisabled = authDialogStore.activeModal === 'signUp' && !authDialogStore.agreedTerms;

    return (
        <>
            <Divider gap="large">{t('dialogs.common.or')}</Divider>

            <div className="grid gap-vsmall">
                {isDisabled ? (
                    <Tooltip content={t('layout.forms.common.agreeTermsValidation')} position={'top'} block>
                        <Button block onClick={onGoogleLogin} variant="google" icon={<IconGoogle />} disabled>
                            {t('dialogs.common.loginGoogle')}
                        </Button>
                    </Tooltip>
                ) : (
                    <Button block onClick={onGoogleLogin} variant="google" icon={<IconGoogle />}>
                        {t('dialogs.common.loginGoogle')}
                    </Button>
                )}

                {isDisabled ? (
                    <Tooltip content={t('layout.forms.common.agreeTermsValidation')} position={'top'} block>
                        <Button block onClick={onAppleLogin} variant="apple" icon={<IconApple />} disabled>
                            {t('dialogs.common.loginApple')}
                        </Button>
                    </Tooltip>
                ) : (
                    <Button block onClick={onAppleLogin} variant="apple" icon={<IconApple />}>
                        {t('dialogs.common.loginApple')}
                    </Button>
                )}
            </div>
        </>
    );
});
